import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/anime';
import AnimeCard from '@/pages/home/components/AnimeCard';

export default function FeaturedSection() {
  const featured = animeList.filter((a) => a.featured).slice(0, 6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50" id="ranking">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              热门推荐
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              大家都在看
            </h2>
            <p className="text-sm text-foreground-500 mt-2">精选高分热门番剧，口碑爆棚不容错过</p>
          </div>
          <Link
            to="/category/rexue"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((anime) => (
            <AnimeCard key={anime.id} {...anime} />
          ))}
        </div>

        <Link
          to="/category/rexue"
          className="flex sm:hidden items-center justify-center gap-1 mt-6 text-sm text-primary-600 font-medium whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}